<template>
    <div class="bigBoss">
        <el-dialog
                :title="'更换代理商'"
                width="50%"
                :visible="toolsIsShow"
                :close-on-click-modal="false"
                @close="handleClose"
        >
            <el-form label-position="top" label-width="80px" :model="infoForm">

                    <el-form-item label="代理商手机号：">
                        <h2 style="color: #af0000">{{dialogData.data.merchant_name}}->即将转移到->{{name}}</h2>
                        <el-input
                                clearable
                                v-model="msg"
                                placeholder="请输入代理商手机号"
                                style="width:100%"
                        ></el-input>
                        <br />
                    </el-form-item>

                <el-button
                        type="primary"
                        style="margin-top:10px;"
                        @click="submit(infoForm)"
                        :loading="submitLoading"
                >点击提交</el-button>

            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "merchantNetTools",
        props: {
            toolsIsShow: {
                type: Boolean,
                default: false
            },
            isAdd: {
                type: [String, Boolean]
            },
            dialogData: {
                type: Object
            }
        },

        watch:{
            /*customerMobile (val, oldval) {
                if (val.length === 11) {
                    console.log("666");
                    this.handleCustomerChange(infoForm)
                }
            },*/
            msg:function(newV,oldV){
                if(newV.length === 11){
                    this.handleCustomerChange(newV);
                }
            }

        },
        computed : {
            customerMobile () {
                return this.infoForm.mobile
            }
        },
        data() {
            return {
                msg:'',
                name:'',
                uploadUrl:'',
                templateUrl: '',
                statusIsShow: false,
                brandList: [], //下拉框
                infoForm: {
                    phone: '',
                },
                upText: '',
                headers: {
                    'Organization-Code': location.hostname.split('.')[0],
                    'Authorization': 'Bearer' + sessionStorage.getItem('token')
                },
                dataStatus: {
                    total: '', //总数
                    successCount: '', //成功条数
                },
                action: '',
                submitLoading: false,
            };
        },
        mounted() {

        },
        methods: {
            submit(infoForm) { //提交
                if (!this.msg) {
                    this.$message.error('请选择输入代理商手机号');
                }else {
                    this.$api.post('merchant/merchantchange', { merchant_id:this.dialogData.data.merchant_id,phone:this.msg}, res => {
                        if (res.code == 0) {
                            //console.log(res, 'res');
                            this.$message({
                                type: 'success',
                                duration: 1500,
                                message: res.msg,
                                handleClose() {
                                    that.handleClose(1);
                                }
                            });
                            this.toolsIsShow = false;
                        }else{
                            this.$message.error(res.msg);
                            //this.submitLoading = false;
                        }
                    })
                }

            },
            handleClose(ref) { //关闭弹窗
                this.$emit('toolsClose', ref);
            },
            // 输入手机号，客户名称联系人联动
            handleCustomerChange(newV){
                this.$api.post("user/getname",{mobile:newV},res => {
                    if (res.code == 0) {
                        console.log(res, 'res');
                        this.name =res.data[0].real_name,
                        this.$message({
                            type: 'success',
                            duration: 1500,
                            message: '确认姓名',
                        });
                    } else {
                        this.$message({
                            type: 'error',
                            message: '手机号不存在',
                            duration: 5000
                        })
                    }
                })
            }
        }
    };


</script>

<style scoped lang="scss">
    .bigBoss {
        font-size: 12px;
        .el-input__inner,
        .tips {
            font-size: 12px;
        }

        .el-form-item {
            margin-bottom: 5px;
        }

        ::v-deep .el-form-item__label {
            padding: 0;
            font-size: 12px;
        }
        .titleTip {
            padding: 10px 10px;
            background-color: #ecf8ff;
            border-radius: 4px;
            font-size: 13px;
            font-weight: 700;
            border-left: 5px solid #50bfff;
            margin: 10px 0;
        }
        ::v-deep .el-dialog{
            min-width: 500px;
        }
    }
</style>